import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Matches backend DEFAULT_TIMEZONE in chaild-api requestContext.ts */
export const DEFAULT_TIMEZONE = 'Asia/Phnom_Penh';

export const formatChatTime = (
  time: string,
  selectedDate: string,
  options?: { multiline?: boolean },
): string => {
  const zoned = dayjs(time).tz(DEFAULT_TIMEZONE);
  const created = zoned.format('YYYY-MM-DD');
  const selected = dayjs(selectedDate).format('YYYY-MM-DD');
  if (created === selected) {
    return zoned.format('HH:mm');
  }
  return options?.multiline
    ? zoned.format('DD/MM\nHH:mm')
    : zoned.format('DD/MM HH:mm');
};
